import LinearListObject from "./LinearListObject";

/**
 * @class LinearListObjectItem
 */
export default class LinearListObjectItem extends LinearListObject {
    /**
     * @param {Number}  id
     * @param {String}  key
     * @param {Number}  index
     * @param {String}  displayName
     * @param {String}  code
     * @param {Boolean} last
     */
    constructor(id, key, index, displayName, code, last) {
        super(id, key, index, displayName);

        this._code = code;
        this._last = last;
    }

    /**
     * @return {String}
     */
    get code() {
        return this._code;
    }

    /**
     * @return {Boolean}
     */
    get last() {
        return this._last;
    }

    /**
     * @param {Boolean} last
     */
    set last(last) {
        this._last = last;
    }

    /**
     * @return {Boolean}
     */
    isItem = () => {
        return true;
    };
}
